import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { ButtonClose } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../../components/TitlePage/TitlePage';
import { StepItem } from '../../../../components/StepItem/StepItem';
import { SelectedColorsComponent } from '../../../../components/SelectedColorsComponent/SelectedColorsComponent';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalSelectedColorColumn.scss'

interface Color {
    color: string;
    color_name: string;
}

const colors: Color[] = [
    {
        color: '#e6d7c1',
        color_name: 'песочный'
    },
    {
        color: '#ffe5d0',
        color_name: 'кремово-оранжевый'
    },
    {
        color: '#ffc9a0',
        color_name: 'светло-оранжевый'
    },
    {
        color: '#f5e6aa',
        color_name: 'светло-желтый'
    },
    {
        color: '#fffacd',
        color_name: 'лимонный крем'
    },
    {
        color: '#e8f0c9',
        color_name: 'лимонный'
    },
    {
        color: '#d9e8d5',
        color_name: 'мятный'
    },
    {
        color: '#d5edc9',
        color_name: 'салатовый'
    },
    {
        color: '#c9f0e8',
        color_name: 'аквамарин'
    },
    {
        color: '#c9e8f0',
        color_name: 'небесный'
    },
    {
        color: '#d4e2f0',
        color_name: 'нежно-голубой'
    },
    {
        color: '#c9d9f0',
        color_name: 'голубой'
    },
    {
        color: '#e2c9f0',
        color_name: 'фиолетовый'
    },
    {
        color: '#d4c9f0',
        color_name: 'лиловый'
    },
    {
        color: '#f0c9e2',
        color_name: 'малиновый'
    },
    {
        color: '#ffa8a8',
        color_name: 'нежно-красный'
    },
    {
        color: '#e9ecef',
        color_name: 'ледяной серый'
    },
    {
        color: '#d4d8dc',
        color_name: 'пепельный'
    },

]

interface ModalSelectedColorColumnProps {
    setIsModal: (e: boolean) => void
    id: number | string
    color: string | null
    updateCol: () => void
    crm: boolean
    ticket: boolean
    task: boolean
}

const ModalSelectedColorColumn = ({
    setIsModal,
    id,
    color,
    updateCol,
    crm = false,
    ticket = false,
    task = false
}: ModalSelectedColorColumnProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const selectedColor = colors.filter((col) => color == col?.color)
    const [currentColor, setCurrentColor] = useState(selectedColor?.[0])

    // Установка цвета
    const fetchSetColor = (color: Color | null) => {
        let url = ` https://portals.ecomru.ru/api/crm/steps/color`
        if (ticket) {
            url = ` https://portals.ecomru.ru/api/ticket/step/color`
        }

        const body = JSON.stringify({
            step_id: id,
            color: color?.color
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => updateCol())
            .catch((err) => console.error(err));
    }

    return (
        <ModalComponent
            title={'Установите цвет колонки'}
            onClose={e => setIsModal(false)}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-selected-color-column'>
                    <div className='modal-selected-color-column__content'>
                        <StepItem
                            title='Выберите цвет'
                        />

                        <SelectedColorsComponent
                            colors={colors}
                            currentColor={currentColor}
                            setCurrentColor={setCurrentColor}
                            fetchSetColor={fetchSetColor}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalSelectedColorColumn }